var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "attach"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M15.8643 8.17462L9.10259 14.9363C7.5649 16.474 5.07182 16.474 3.53413 14.9363C1.99644 13.3986 1.99644 10.9056 3.53413 9.36786L10.2958 2.60616C11.321 1.58103 12.983 1.58103 14.0081 2.60616C15.0333 3.63128 15.0333 5.29334 14.0081 6.31847L7.5116 12.815C6.99904 13.3276 6.16801 13.3276 5.65545 12.815C5.14288 12.3024 5.14288 11.4714 5.65545 10.9589L11.3565 5.25781",
    stroke: "#172B4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.1fa399493ceeb7ffdf32c27b01e5f4b3.svg";
export { ForwardRef as ReactComponent };